<template>
  <div id="errandite">
    <div class="loading" v-if="state.loading == true">
      <h1>Errandite</h1>
    </div>
    <div v-if="state.user == null && state.loading == false" class="container">
      <ErranditeLogin v-bind:state="state" v-bind:data="data"/>
    </div>
    <div v-if="state.user != null && state.loading == false" class="container">
      <!--<ErranditeBreadcrumb v-bind:state="state" v-bind:data="data" v-if="state.breadcrumb.length > 0"/>-->
      
      <div class="pages">
        <div class="page">
          <ul class="tasks">
            <div class="breadcrumbs">
              <span class="breadcrumb current">
                <span class="breadcrumb">Today</span>
              </span>
            </div>
            <ErranditeTask v-for="task in data.today" v-bind:key="task" v-bind:task="task" v-bind:state="state" v-bind:data="data"/>
          </ul>
          <ul class="tasks">
            <div class="breadcrumbs">
              <span class="breadcrumb current">
                <span class="breadcrumb">Overdue</span>
              </span>
            </div>
            <ErranditeTask v-for="task in data.overdue" v-bind:key="task" v-bind:task="task" v-bind:state="state" v-bind:data="data"/>
          </ul>
          <ul class="tasks padded">
            <div class="breadcrumbs">
              <span class="breadcrumb current">
                <span class="breadcrumb">My projects</span>
              </span>
            </div>
            <ErranditeTask v-for="task in data.projects" v-bind:key="task" v-bind:task="task" v-bind:state="state" v-bind:data="data"/>
          </ul>
        </div>
        <transition-group name="pages">
          <ErranditePage v-for="page in state.breadcrumb" v-bind:key="page" v-bind:task="page" v-bind:state="state" v-bind:data="data"/>
        </transition-group>
      </div>
      <ErranditeAdd v-bind:state="state" v-bind:data="data"/>
    </div>
  </div>
</template>

<script>
import ErranditeTask from './components/ErranditeTask.vue'
import ErranditePage from './components/ErranditePage.vue'
import ErranditeBreadcrumb from './components/ErranditeBreadcrumb.vue'
import ErranditeAdd from './components/ErranditeAdd.vue'
import ErranditeLogin from './components/ErranditeLogin.vue'

import { auth, usersCollection, tasksCollection } from './components/firebase'

export default {
  name: 'app',
  data: function() {
    return {
      state: {
        breadcrumb: [],
        adding: false,
        user: null,
        loading: true,
        editing: false,
        colours: [
          "#7EB814",
          "#48B814",
          "#14B817",
          "#14B84D",
          "#14B884",
          "#14B5B8",
          "#168BCA",
          "#195AE6",
          "#3835E9",
          "#6722E7",
          "#9E18DD",
          "#B814B5",
          "#B8147F",
          "#B81448",
          "#B81714",
          "#B84D14",
          "#B88414",
          "#B5B814"
        ]
      },
      data: {
        //projects: ["10d04e06-f5d2-4315-a451-9db7717ee59f"],
        projects: [],
        overdue: [],
        today: [],
        tasks: {
          "10d04e06-f5d2-4315-a451-9db7717ee59f": {
            label: "Test project 1",
            tasks: [
              "9ab03058-e34f-4c3b-8e6b-302c6cdc5d61",
              "f78060f0-fcb3-40be-a555-6a24c361d021"
            ],
            completed: null,
            due: null
          },
          "9ab03058-e34f-4c3b-8e6b-302c6cdc5d61": {
            label: "Test task 1",
            tasks: [],
            completed: null,
            due: null
          },
          "f78060f0-fcb3-40be-a555-6a24c361d021": {
            label: "Test task 2",
            tasks: [],
            completed: null,
            due: null
          }
        }
      }
    }
  },
  mounted: function() {
    var er = this;
    setTimeout(function() {
      er.state.loading = false;
    }, 2000);
    
    auth.onAuthStateChanged(function(user) {
      if (user) {
        er.state.user = user;
        console.log(user);
        er.getUser();
      } else {
        er.state.user = null;
      }
      er.state.loading = false;
    });
  },
  watch: {
    "data.projects": function() {
      
    },
    "data.tasks": {
      deep: true,
      handler: function(task) {
        console.log(task);
        this.processToday();
      }
    }
  },
  methods: {
    getUser: function() {
      var er = this;
      var docRef = usersCollection.doc(this.state.user.uid);

      docRef.get().then(function(doc) {
          if (doc.exists) {
              console.log("Document data:", doc.data());
              var userData = doc.data();
              for (var i=0; i<userData.projects.length; i++) {
                er.data.projects.push(userData.projects[i]);
              }
          } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              docRef.set({
                  projects: []
              })
              .then(function() {
                  console.log("Document successfully written!");
              })
              .catch(function(error) {
                  console.error("Error writing document: ", error);
              });

          }

          er.getToday();
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
    },
    getToday: function() {
      var er = this;

      var todayTasks = {};

      tasksCollection.where("end", "<", new Date()).get().then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              console.log(doc.id, " => ", doc.data());
              
              var taskData = er.getTask(doc);
             
              todayTasks[doc.id] = taskData;
          });

          tasksCollection.where("start", "<", new Date()).get().then(function(querySnapshot2) {
              querySnapshot2.forEach(function(doc) {
                  // doc.data() is never undefined for query doc snapshots
                  console.log(doc.id, " => ", doc.data());

                  if (todayTasks[doc.id] == undefined) {

                    var taskData = er.getTask(doc);
                    todayTasks[doc.id] = taskData;

                  }

              });

              //er.processToday(todayTasks);

          }).catch(function(error) {
              console.log("Error getting documents: ", error);
          });
      }).catch(function(error) {
          console.log("Error getting documents: ", error);
      });

      
      
    },
    getTask(doc) {
      var er = this;

      var taskData = doc.data();
      if (taskData.start != null) {
        taskData.start = taskData.start.toDate();
      }
      if (taskData.end != null) {
        taskData.end = taskData.end.toDate();
      }
      er.$set(er.data.tasks, doc.id, taskData);
      return taskData;
    },
    processToday: function() {
      var todayTasks = this.data.tasks;

      var er = this;

      var now = new Date();
      
      var midnightToday = new Date();
      midnightToday.setHours(0,0,0,0);

      var midnightTonight = new Date();
      midnightTonight.setHours(24,0,0,0);

      var overdue = [];
      var today = [];

      console.log(todayTasks);

      for (var key in todayTasks) {
        if (todayTasks[key].tasks != undefined && todayTasks[key].tasks.length == 0 && todayTasks[key].end != null) {
          if (todayTasks[key].end < midnightToday) {// || (todayTasks[key].end < now && todayTasks[key].time == true)) {
            overdue.push(key);
          } else if (todayTasks[key].end < midnightTonight || todayTasks[key].start < midnightToday) {
            today.push(key);
          }
        }
      }

      overdue.sort(function(a, b) {
        if (er.data.tasks[a].end < er.data.tasks[b].end) {
          return -1;
        } else {
          return 1;
        }
      });

      today.sort(function(a, b) {
        var minA = er.data.tasks[a].end;
        if (er.data.tasks[a].start != null) {
          minA = er.data.tasks[a].start;
        }
        var minB = er.data.tasks[b].end;
        if (er.data.tasks[b].start != null) {
          minB = er.data.tasks[b].start;
        }
        
        if (minA < minB) {
          return -1;
        } else {
          return 1;
        }
      });

      this.$set(this.data, 'overdue', overdue);
      this.$set(this.data, 'today', today);

      /*for (var i=0; i<overdue.length; i++) {
        this.data.overdue.push(overdue[i]);
      }

      for (var i=0; i<today.length; i++) {
        this.data.today.push(today[i]);
      }*/
    }
  },
  components: {
    ErranditeTask,
    ErranditePage,
    ErranditeBreadcrumb,
    ErranditeAdd,
    ErranditeLogin
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;600;800&display=swap');
@import "./styles/_variables.scss";

#errandite {
  font-family: 'Heebo', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  color: $white;

  font-size: 16px;

  .container, .loading {
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .loading {
    background-color: $dark;
    justify-content: center;
    align-items: center;
  }

  ul.tasks {
    margin: 0px;
    padding: 0px;
  }

  

  .pages {
    flex: 0 1 100%;
    position: relative;
  }

  .page {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: $dark;
    overflow: auto;
  }

  h1, h2, h3 {
    .icon {
      margin-right: $padding/2;
    }
  }

  input {
    font-family: 'Heebo', sans-serif;
    font-size: 16px;
    padding: $padding;
    background: transparent;
    border: 2px solid $highlight;
    border-radius: $borderRadius;
    color: $highlight;
    box-sizing: border-box;
    width: 100%;
  }

  .breadcrumbs {
    flex: 1 0 auto;
    padding: $padding;
    padding-top: calc(#{$padding} + env(safe-area-inset-top));
    border-bottom: 1px solid $dark2;
    background-color: $dark2transparent;
    backdrop-filter: blur(10px);
    position: sticky;
    top: 0px;

    &.bar {
      
      background-color: $dark;
    }

    .breadcrumb {
      cursor: pointer;

      &.current {
        display: block;
        font-size: 24px;
        font-weight: 600;
        display: flex;
        justify-content: stretch;
        align-items: center;

        .breadcrumb {
          flex: 1 1 auto;
          display: flex;
        }
      }

      &.back {
        flex: 0 0 auto;

        .icon {
          margin: 0 $padding 0 0 ;
        }
      }

      &:hover {
        opacity: 0.8;
      }

      span.right {
        /*float: right;*/
        flex: 0 0 auto;

        .icon {
          margin-left: $padding;
          margin-right: 0;
        }
      }

      .breadcrumbIcon {
        display: inline-block;
        margin-right: $padding/4;

        .circle.project {
          margin-left: 0;
          margin-top: 0px;
          margin-bottom: 0px;
        }
      }
    }

    .icon {
      margin: 0 $padding/2;
    }
  }

  .circle {
		flex: 0 0 auto;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 2px solid $light;
		margin: $padding $padding/4 $padding $padding;
		background-color: rgba(255, 255, 255, 0);
		display: flex;
		align-items: center;
		justify-content: center;

		.icon {
			opacity: 0;
			font-size: 24px;
		}

		&.project {
			border: 0px;
			width: 36px;
			height: 36px;
			background-color: $dark2;
			
			.icon {
				font-size: 18px;
			}
		}

		&.complete, &.project {
			.icon {
				opacity: 1;
				display: block;
			}
		}

		&:hover {
			.icon {
				opacity: 0.5;
			}

			&.complete {
				.icon {
					opacity: 0.75;
				}
			}
		}

	}
}

.pages-enter-active, .pages-leave-active {
  transition: all 0.5s;
}
.pages-enter, .pages-leave-to /* .list-leave-active below version 2.1.8 */ {
  filter: blur(10px);
  transform: translateX(100%);
}

</style>